const containerStyle = {
  backgroundColor: "white",
  marginTop: "15px",
  padding: "32px",
};

export default containerStyle;
